<template>
  <div v-if="client" class="virtual-card-wrap">
    <div class="card-container">
      <div v-if="client.used" class="used-card d-flex align-items-center justify-content-center">
        <span class="used-card-text">USED</span>
      </div>
      <div :id="'virtual-card-container-' + client.card_token" class="card-common front-card">
        <div class="section-top">
          <div class="type-card">
            <div class="type-card-text">
              <h4>{{ lang.vcc.SFS_LANG_ROW_10 }}</h4>
              <h4>
                Valid for: <strong>{{ valid }}</strong>
              </h4>
              <h4>Value: {{ client.currency }} {{ client.amount }}</h4>
            </div>
          </div>
          <div v-if="airline && airline.template_config && airline.template_config.logo_creditcard_mobile" style="flex: 1">
            <img style="width: 150px" :src="airline.template_config.logo_creditcard_mobile" />
          </div>
          <div v-else class="logo-card"></div>
        </div>
        <div :id="'mq-card-pan-' + client.card_token" class="container-row card-pan"></div>
        <div class="section-date-thru">
          <div class="type-card"></div>
          <div class="date-valid-thru">
            <div class="content">
              <div class="in-left">
                <h4>VALID</h4>
                <h4>THRU</h4>
              </div>
              <div class="in-right">
                <i class="fas fa-caret-right"></i>
                <h4>MM/YYYY</h4>
                <div :id="'mq-card-exp-' + client.card_token" class="container-row card-exp"></div>
              </div>
            </div>
          </div>
          <div class="type-card">
            {{ lang.vcc.SFS_LANG_ROW_11 }}
          </div>
        </div>
        <div v-if="airline && airline.template_config && airline.template_config.logo_visa_card" class="section-logo-card-type">
          <img :src="airline.template_config.logo_visa_card" />
        </div>
        <div v-else class="section-logo-card-type">
          <img src="@/assets/images/master-card.png" />
        </div>
      </div>
    </div>
    <div class="card-container">
      <div v-if="client.used" class="used-card d-flex align-items-center justify-content-center">
        <span class="used-card-text">USED</span>
      </div>
      <div class="card-common back-card">
        <div class="magnetic-strip"></div>
        <div class="signature">
          <div class="cvc-code">
            <div class="code-number-wrap">
              <div :id="'mq-card-cvv-' + client.card_token" class="container-row card-cvv"></div>
            </div>
            <div class="cvc-text">
              <span>CVC Code</span>
            </div>
          </div>
        </div>
        <div v-if="airline && airline.template_config && airline.template_config.logo_visa_card" class="section-logo-card-type">
          <img :src="airline.template_config.logo_visa_card" />
        </div>
        <div v-else class="section-logo-card-type">
          <img src="@/assets/images/master-card.png" />
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="airline.params.show_fake_card_on_mobile" class="virtual-card-wrap">
    <div class="card-container">
      <div class="card-common front-card">
        <div class="section-top">
          <div class="type-card">
            <div class="type-card-text">
              <h4>{{ lang.vcc.SFS_LANG_ROW_10 }}</h4>
              <h4>
                Valid for: <strong>{{ valid }}</strong>
              </h4>
              <h4 v-if="amount">Value: EUR {{ amount }}</h4>
            </div>
          </div>
          <div v-if="airline && airline.template_config && airline.template_config.logo_creditcard_mobile" style="flex: 1">
            <img style="width: 150px" :src="airline.template_config.logo_creditcard_mobile" />
          </div>
          <div v-else class="logo-card"></div>
        </div>
        <div class="container-row card-pan">1184 5794 3984 7411</div>
        <div class="section-date-thru">
          <div class="type-card"></div>
          <div class="date-valid-thru">
            <div class="content">
              <div class="in-left">
                <h4>VALID</h4>
                <h4>THRU</h4>
              </div>
              <div class="in-right">
                <i class="fas fa-caret-right"></i>
                <h4>MM/YYYY</h4>
                <div class="container-row card-exp">{{ moment().add(6, 'M').format('MM/YYYY') }}</div>
              </div>
            </div>
          </div>
          <div class="type-card">
            {{ lang.vcc.SFS_LANG_ROW_11 }}
          </div>
        </div>
        <div v-if="airline && airline.template_config && airline.template_config.logo_visa_card" class="section-logo-card-type">
          <img :src="airline.template_config.logo_visa_card" />
        </div>
        <div v-else class="section-logo-card-type">
          <img src="@/assets/images/master-card.png" />
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="card-common back-card">
        <div class="magnetic-strip"></div>
        <div class="signature">
          <div class="cvc-code">
            <div class="code-number-wrap">
              <div class="container-row card-cvv">533</div>
            </div>
            <div class="cvc-text">
              <span>CVC Code</span>
            </div>
          </div>
        </div>
        <div v-if="airline && airline.template_config && airline.template_config.logo_visa_card" class="section-logo-card-type">
          <img :src="airline.template_config.logo_visa_card" />
        </div>
        <div v-else class="section-logo-card-type">
          <img src="@/assets/images/master-card.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/scss/modules/CreditCard.scss'
export default {
  name: 'MasterCard',
  props: {
    valid: {
      type: String,
      default: ''
    },
    client: {
      type: Object,
      default: () => {}
    },
    amount: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      newValid: '',
      checkValid: false
    }
  },
  mounted() {
    if (typeof marqeta === 'undefined' || _.isUndefined(this.client)) {
      return
    }
    if (this.valid != '') {
      this.checkValid = true
    } else {
      this.checkValid = false
    }
    let _this = this
    let subID = '' + this.client.card_token
    marqeta.bootstrap({
      clientAccessToken: this.client.client_access_token,
      integrationType: 'custom',
      containerId: 'virtual-card-container-' + subID,
      showPan: {
        cardPan: {
          domId: 'mq-card-pan-' + subID,
          format: true,
          styles: {
            span: {
              'font-size': '1.5625rem',
              color: '#72707b',
              'font-weight': '700',
              'font-family': 'sans-serif'
            }
          }
        },
        cardExp: {
          domId: 'mq-card-exp-' + subID,
          format: true,
          styles: {
            span: {
              'font-size': '0.9375rem',
              color: '#72707b',
              'font-weight': '700',
              'font-family': 'sans-serif'
            }
          }
        },
        cardCvv: {
          domId: 'mq-card-cvv-' + subID,
          styles: {
            span: {
              'font-size': '0.9375rem',
              color: '#72707b',
              'font-weight': '700',
              'font-family': 'sans-serif'
            }
          }
        }
      },
      callbackEvents: {
        onSuccess() {
          _this.$emit('loadSuccess', true)
        }
      }
    })
  },
  updated() {}
}
</script>
